import { Box } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { detailsTickets } from 'src/redux/Calendar/sliceCalendar';
import { OptionsMasterUpdateForm } from './OptionsMasterUpdateForm';
import { OptionsUpdateForm } from './OptionsUpdateForm';
import { customFormat } from 'src/helpers/DateFormat';

export const OptionsContent = () => {
  const data = useSelector(detailsTickets);
  if (!data) return null;
  return (
    <>
      <OptionsMasterUpdateForm />
      {Object.keys(data).map((i) => (
        <OptionsUpdateForm key={i} state={data[i]} date={i} />
      ))}
    </>
  );
};
